import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  title: {
    letterSpacing: '-0.4px',
    marginBottom: theme.spacing(4),
    width: '80%',
    [theme.breakpoints.down('md')]: {
      letterSpacing: 'initial',
      marginBottom: theme.spacing(2.5),
      width: '95%',
    },
  },
  buttons: {
    [theme.breakpoints.down('lg')]: {
      '& #accept-button': {
        width: 110,
      },
    },
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing(4),
    },
  },
}));
